export class KeyFramesContent {
}
